import axios from 'axios'

export interface DatTokenOwner {
    userId: string
    projectName: string | null
    projectNames: string[]
    email: string | null
    source: string
    expiresAt: string | null
}

interface ProtectionResponse {
    blockedProjectNames: string[]
    owners: DatTokenOwner[]
}

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

async function update(path: string, projectName: string): Promise<{ blockedProjectNames: string[] }> {
    const response = await axios.post<Envelope<{ blockedProjectNames: string[] }>>(`/gluon/dat-token-protection/${path}`, { projectName })
    return response.data.data
}

export const datTokenProtectionApi = {
    async get(): Promise<ProtectionResponse> {
        const response = await axios.get<Envelope<ProtectionResponse>>('/gluon/dat-token-protection')
        return response.data.data
    },
    block: (projectName: string) => update('block', projectName),
    unblock: (projectName: string) => update('unblock', projectName),
}
